import { useFeatures } from '@/contexts/root-store-context'

export function useTranslate() {
  const { translate } = useFeatures(({ iam }) => ({
    translate: iam.translationStore.translate,
  }))

  return translate
}
